// Turks (tr-TR), Ayarlar · Bildirimler (0038_meldingen): zelfde vorm als pushApp.nl.ts. Sen-vorm
// (zoals app.tr.ts); "ailen" voor jullie gezin.
export const appPushTr = {
    title: 'Bildirimler',
    subtitle: 'Telefonunda küçük hatırlatmalar. Ne alacağını sen seçersin.',
    settingsBody: 'Hatırlatmalar, ulaşım ve mesajlar telefonunda',
    device: {
        title: 'Bu cihazda',
        on: 'Bu cihazda bildirimler açık.',
        off: 'Bu cihazda bildirimler henüz kapalı.',
        turnOn: 'Bildirimleri aç',
        turnOff: 'Bu cihazda kapat',
        test: 'Deneme bildirimi gönder',
        testSent: 'Deneme bildirimi gönderildi. Birazdan gelir.',
        testNone: 'Henüz kayıtlı bir telefon yok.',
        testOff: 'Bu sunucuda gönderim kapalı.',
        turnedOn: 'Bildirimler açık',
        turnedOff: 'Bu cihazda bildirimler kapalı',
        denied: 'Tarayıcın AMUMIN bildirimlerini engelliyor. Tarayıcının ya da telefonunun ayarlarından izin ver, sonra buraya geri dön.',
        unsupported: 'Bu tarayıcı bildirim alamıyor.',
        nativeApp: 'AMUMIN iPhone uygulamasına henüz bildirim gelmiyor. Şimdiden almak mı istiyorsun? AMUMIN’i Safari’de aç ve ana ekranına ekle.',
        unavailable: 'Bildirimler henüz ayarlanmadı. Daha sonra tekrar dene.',
        needsInstall: 'iPhone ve iPad’de bildirimler yalnızca AMUMIN ana ekranındaysa gelir. Önce onu oraya ekle (aşağıya bak), sonra AMUMIN’i ana ekranından aç.',
        notAllowedChild: 'Bildirimlerini bir ebeveyn açar.',
        inUse: 'Bu tarayıcı ailende başka biri için zaten kayıtlı.',
        nothingChosen: 'Hiçbir şey seçmedin, bildirim gelmeyecek.',
        loginNote: 'Bu cihazda oturumun açık olduğu sürece bildirimler gelir. Çıkış yaparsan dururlar.',
    },
    install: {
        title: 'AMUMIN’i ana ekranına ekle',
        body: 'Böylece AMUMIN’i bir uygulama gibi tek dokunuşla açarsın. Ücretsiz, bir şey indirmen gerekmez.',
        installed: 'AMUMIN ana ekranında.',
        platform: 'Hangi cihaz?',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'Bilgisayar',
        iosNote: 'Bildirimler iOS 16.4 ve sonrasında, AMUMIN ana ekranındaysa çalışır.',
        androidButton: 'AMUMIN’i yükle',
        desktopButton: 'AMUMIN’i yükle',
    },
    kinds: {
        title: 'Ne almak istersin?',
        autosave: 'İşaretlediğin her şey hemen kaydedilir.',
        reminders: 'Hatırlatmalarım',
        remindersHint: 'Tabletin seslendiği anda.',
        remindersChildren: 'Çocuklarımın hatırlatmaları da',
        rides: 'Ulaşım',
        ridesHint: '"Yakub’u yarın 08:15’te kim götürür?" ve bir yolculuğu kimin üstlendiği.',
        approvals: 'Onayımı bekleyenler',
        approvalsHint: 'Tek bir bildirimde, en fazla yarım saatte bir.',
        messages: 'Yeni mesajlar',
        departure: 'Yola çıkma zamanı',
        departureHint: 'Randevuda yolculuk süresi varsa.',
        summary: 'Günün özeti',
        summaryHint: 'Her gün takvimin kısa bir özeti.',
        summaryAt: 'Saat',
    },
    quiet: {
        title: 'Sessiz saatler',
        toggle: 'Sessiz saatlerde bildirim yok',
        from: 'Başlangıç',
        to: 'Bitiş',
        note: 'Kendin için kurduğun hatırlatmalar yine de gelir.',
    },
    discreet: {
        title: 'Kilit ekranında gizli',
        body: 'Bildirimler Apple, Google, Mozilla ya da Microsoft’un hizmetinden şifreli geçer. O hizmet onları okuyamaz. Ama kilit ekranını herkes görebilir. Bu yüzden varsayılan olarak yalnızca "AMUMIN" ve bildirimin türü görünür.',
        all: 'Her şey gizli',
        allHint: 'Varsayılan olarak açık. Yalnızca "AMUMIN" ile "Bir hatırlatma", "Götürme ve getirme ile ilgili bir şey", "Onayını bekleyen bir şey var" ya da "Yeni bir mesaj" görürsün. Bunu kapatırsan ayrıntıları görürsün: başlık, isimler, saat, yer ve mesajın metni.',
        sensitive: 'İnanç, sağlık ve okul gizli',
        sensitiveHint: 'Ayrıntılar açıkken bile: bir randevunun, hatırlatmanın ya da mesajın sağlık, inanç ya da okulla ilgili olduğunu simgeden ya da "doktor", "ramazan", "cami", "karne" veya "sınav" gibi kelimelerden anlarsak bildirim gizli kalır. Hiçbir kelime listesi eksiksiz değildir: emin değilsen her şeyi gizli bırak.',
    },
    children: {
        title: 'Çocuklar',
        body: 'Kendi girişi olan bir çocuk da, sen uygun görürsen bildirim alabilir. Varsayılan olarak kapalı.',
        allow: '{name} için bildirimler',
        noLogin: '{name} için ayrı bir giriş yok.',
        none: 'Ailende henüz çocuk yok.',
        toastOn: '{name} artık bildirim alabilir',
        toastOff: '{name} artık bildirim almıyor',
    },
    devices: {
        title: 'Telefonların ve tarayıcıların',
        none: 'Henüz kayıtlı telefon ya da tarayıcı yok.',
        since: '{date} tarihinden beri kayıtlı',
        lastUsed: 'Son bildirim: {date}',
        error: 'Son bildirim ulaşmadı.',
        remove: 'Kaldır',
        removeLabel: 'Kaldır: {name}',
        removed: 'Kaldırıldı',
        thisOne: 'Bu cihaz',
    },
    save: 'Kaydet',
    saved: 'Kaydedildi',
    offTitle: 'Bildirimler kapalı',
    offBody: 'Ailen için bildirimler kapalı. Bir ebeveyn Modüller’den açabilir.',
};
//# sourceMappingURL=pushApp.tr.js.map